import { Action } from '@ngrx/store';
import { CatalogsResponse } from '@cemex-core/cmx-api/models/catalogs/catalogs-response';
import { CatalogsRequest } from '@cemex-core/cmx-api/models/catalogs/catalogs-request';

export const LOAD_CATALOGS = '[Catalogs] Load Catalogs';
export const LOADED_CATALOGS_SUCCESS = '[Catalogs] Catalog Load Success';
export const LOADED_CATALOGS_FAIL = '[Catalogs] Catalog Load Fail';

export class CatalogsLoadAction implements Action {
  readonly type = LOAD_CATALOGS;

  constructor(public payload: CatalogsRequest) {}
}

export class CatalogsLoadedSuccessAction implements Action {
  readonly type = LOADED_CATALOGS_SUCCESS;

  constructor(public payload: CatalogsResponse) {}
}

export class CatalogsLoadedFailAction implements Action {
  readonly type = LOADED_CATALOGS_FAIL;

  constructor(public payload: any) {}
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type CatalogsActions = CatalogsLoadAction | CatalogsLoadedSuccessAction | CatalogsLoadedFailAction;
